import { render, staticRenderFns } from "./BusinessCardSignup.vue?vue&type=template&id=19090cc4&scoped=true&"
import script from "./BusinessCardSignup.vue?vue&type=script&lang=js&"
export * from "./BusinessCardSignup.vue?vue&type=script&lang=js&"
import style0 from "./BusinessCardSignup.vue?vue&type=style&index=0&id=19090cc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19090cc4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VRow,VSelect,VTextField})
